import React from 'react'
import PropTypes from 'prop-types'

import { Phrase } from './Phrases.style'

// Renders a title split on '|' so lines break between phrases, never inside one when it fits.
const Phrases = ({ text }) => {
  const phrases = text.split('|').map((phrase) => phrase.trim())

  return phrases.map((phrase, index) => (
    <React.Fragment key={index}>
      <Phrase>{phrase}</Phrase>
      {index < phrases.length - 1 && ' '}
    </React.Fragment>
  ))
}

Phrases.propTypes = {
  text: PropTypes.string.isRequired,
}

export default Phrases
